export enum PropertyType {
  SmallText = 'small-text',
  LongText = 'long-text',
  Number = 'number',
  Date = 'date',
  Time = 'time',
  Duration = 'duration',
  SingleSelect = 'single-select',
  MultiSelect = 'multi-select',
  Media = 'media',
}

export const PropertyTypeLabels: Record<PropertyType, string> = {
  [PropertyType.SmallText]: 'Small Text',
  [PropertyType.LongText]: 'Long Text',
  [PropertyType.Number]: 'Number',
  [PropertyType.Date]: 'Date',
  [PropertyType.Time]: 'Time',
  [PropertyType.Duration]: 'Duration',
  [PropertyType.SingleSelect]: 'Single Select',
  [PropertyType.MultiSelect]: 'Multi Select',
  [PropertyType.Media]: 'Media',
};
